// extracted by mini-css-extract-plugin
export default {"root":"BlockPageList_root__I+qv6","media":"BlockPageList_media__2TL+f","text":"BlockPageList_text__aUgs2","cta":"BlockPageList_cta__SIBRq","title":"BlockPageList_title__-AzOW"};